/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAuthDto } from '../models/work-auth-dto';
import { WorkGetMailsAndPhonesDto } from '../models/work-get-mails-and-phones-dto';
import { WorkMailsAndPhonesDto } from '../models/work-mails-and-phones-dto';
import { WorkRefreshtokenDto } from '../models/work-refreshtoken-dto';
import { WorkRequestOtpDto } from '../models/work-request-otp-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkTokenResponseDto } from '../models/work-token-response-dto';
import { WorkVerifyOtpDto } from '../models/work-verify-otp-dto';

@Injectable({ providedIn: 'root' })
export class WorkAuthenticationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authenticationV1ControllerLogin()` */
  static readonly AuthenticationV1ControllerLoginPath = '/v1/auth/loginWithUsernameAndPassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV1ControllerLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerLogin$Response(
    params: {
      body: WorkAuthDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTokenResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationService.AuthenticationV1ControllerLoginPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTokenResponseDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV1ControllerLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerLogin(
    params: {
      body: WorkAuthDto
    },
    context?: HttpContext
  ): Observable<WorkTokenResponseDto> {
    return this.authenticationV1ControllerLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTokenResponseDto>): WorkTokenResponseDto => r.body)
    );
  }

  /** Path part for operation `authenticationV1ControllerRefreshToken()` */
  static readonly AuthenticationV1ControllerRefreshTokenPath = '/v1/auth/refreshTokens';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV1ControllerRefreshToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerRefreshToken$Response(
    params: {
      body: WorkRefreshtokenDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTokenResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationService.AuthenticationV1ControllerRefreshTokenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTokenResponseDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV1ControllerRefreshToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerRefreshToken(
    params: {
      body: WorkRefreshtokenDto
    },
    context?: HttpContext
  ): Observable<WorkTokenResponseDto> {
    return this.authenticationV1ControllerRefreshToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTokenResponseDto>): WorkTokenResponseDto => r.body)
    );
  }

  /** Path part for operation `authenticationV1ControllerLogoutOld()` */
  static readonly AuthenticationV1ControllerLogoutOldPath = '/v1/auth/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV1ControllerLogoutOld()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationV1ControllerLogoutOld$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationService.AuthenticationV1ControllerLogoutOldPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV1ControllerLogoutOld$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationV1ControllerLogoutOld(
    params?: {
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.authenticationV1ControllerLogoutOld$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `authenticationV1ControllerLogoutOldPost()` */
  static readonly AuthenticationV1ControllerLogoutOldPostPath = '/v1/auth/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV1ControllerLogoutOldPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationV1ControllerLogoutOldPost$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationService.AuthenticationV1ControllerLogoutOldPostPath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV1ControllerLogoutOldPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationV1ControllerLogoutOldPost(
    params?: {
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.authenticationV1ControllerLogoutOldPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `authenticationV1ControllerGetMailsAndPhones()` */
  static readonly AuthenticationV1ControllerGetMailsAndPhonesPath = '/v1/auth/getMailsAndPhones';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV1ControllerGetMailsAndPhones()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerGetMailsAndPhones$Response(
    params: {
      body: WorkGetMailsAndPhonesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMailsAndPhonesDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationService.AuthenticationV1ControllerGetMailsAndPhonesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMailsAndPhonesDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV1ControllerGetMailsAndPhones$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerGetMailsAndPhones(
    params: {
      body: WorkGetMailsAndPhonesDto
    },
    context?: HttpContext
  ): Observable<WorkMailsAndPhonesDto> {
    return this.authenticationV1ControllerGetMailsAndPhones$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMailsAndPhonesDto>): WorkMailsAndPhonesDto => r.body)
    );
  }

  /** Path part for operation `authenticationV1ControllerGetMailsAndPhonesForContact()` */
  static readonly AuthenticationV1ControllerGetMailsAndPhonesForContactPath = '/v1/auth/getMailsAndPhonesForContact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV1ControllerGetMailsAndPhonesForContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerGetMailsAndPhonesForContact$Response(
    params: {
      body: WorkGetMailsAndPhonesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMailsAndPhonesDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationService.AuthenticationV1ControllerGetMailsAndPhonesForContactPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMailsAndPhonesDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV1ControllerGetMailsAndPhonesForContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerGetMailsAndPhonesForContact(
    params: {
      body: WorkGetMailsAndPhonesDto
    },
    context?: HttpContext
  ): Observable<WorkMailsAndPhonesDto> {
    return this.authenticationV1ControllerGetMailsAndPhonesForContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMailsAndPhonesDto>): WorkMailsAndPhonesDto => r.body)
    );
  }

  /** Path part for operation `authenticationV1ControllerRequestOtp()` */
  static readonly AuthenticationV1ControllerRequestOtpPath = '/v1/auth/requestOtp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV1ControllerRequestOtp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerRequestOtp$Response(
    params: {
      body: WorkRequestOtpDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationService.AuthenticationV1ControllerRequestOtpPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV1ControllerRequestOtp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerRequestOtp(
    params: {
      body: WorkRequestOtpDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.authenticationV1ControllerRequestOtp$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `authenticationV1ControllerVerifyOtp()` */
  static readonly AuthenticationV1ControllerVerifyOtpPath = '/v1/auth/verifyOtp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV1ControllerVerifyOtp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerVerifyOtp$Response(
    params: {
      body: WorkVerifyOtpDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTokenResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationService.AuthenticationV1ControllerVerifyOtpPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTokenResponseDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV1ControllerVerifyOtp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV1ControllerVerifyOtp(
    params: {
      body: WorkVerifyOtpDto
    },
    context?: HttpContext
  ): Observable<WorkTokenResponseDto> {
    return this.authenticationV1ControllerVerifyOtp$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTokenResponseDto>): WorkTokenResponseDto => r.body)
    );
  }

}
